export default __webpack_public_path__ + "static/media/logoMobile.2fa41b9a.png";